<div class="answer-type-field" [class.hide-label]="hideLabel">
  <ng-container [ngSwitch]="inputContent.inputControllerType">
    <ng-container *ngSwitchCase="ControllerTypes.TextBox">
      <answer-textbox class="w-100" [inputContent]="inputContent"
        [formControlObj]="formGroup.controls[inputContent.inputContentGuid]">
      </answer-textbox>
    </ng-container>
    <ng-container *ngSwitchCase="ControllerTypes.TextArea">
      <answer-textarea class="w-100" [inputContent]="inputContent"
        [formControlObj]="formGroup.controls[inputContent.inputContentGuid]">
      </answer-textarea>
    </ng-container>
    <ng-container *ngSwitchCase="ControllerTypes.Numeric">
      <answer-numeric-textbox class="w-100" [inputContent]="inputContent"
        [formControlObj]="formGroup.controls[inputContent.inputContentGuid]">
      </answer-numeric-textbox>
    </ng-container>
    <ng-container *ngSwitchCase="ControllerTypes.RadioButtons">
      <answer-radio class="w-100" [inputContent]="inputContent"
        [formControlObj]="formGroup.controls[inputContent.inputContentGuid]">
      </answer-radio>
    </ng-container>
    <ng-container *ngSwitchCase="ControllerTypes.Dropdown">
      <answer-select class="w-100" [inputContent]="inputContent"
        [formControlObj]="formGroup.controls[inputContent.inputContentGuid]">
      </answer-select>
    </ng-container>
    <ng-container *ngSwitchCase="ControllerTypes.Checkboxes">
      <answer-checkbox class="w-100" [inputContent]="inputContent"
        [formControlObj]="formGroup.controls[inputContent.inputContentGuid]">
      </answer-checkbox>
    </ng-container>
    <ng-container *ngSwitchCase="ControllerTypes.DatePicker">
      <answer-datetime class="w-100" [inputContent]="inputContent"
        [formControlObj]="formGroup.controls[inputContent.inputContentGuid]" [bsConfig]="{
          rangeInputFormat : 'DD/MM/YYYY', dateInputFormat: 'DD/MM/YYYY' 
        }">
      </answer-datetime>
    </ng-container>
    <ng-container *ngSwitchCase="ControllerTypes.TimePicker">
      <answer-datetime class="w-100" [inputContent]="inputContent"
        [formControlObj]="formGroup.controls[inputContent.inputContentGuid]">
      </answer-datetime>
    </ng-container>
    <ng-container *ngSwitchCase="ControllerTypes.Toggle">
      <answer-toggle class="w-100" [inputContent]="inputContent"
        [formControlObj]="formGroup.controls[inputContent.inputContentGuid]">
      </answer-toggle>
    </ng-container>
    <ng-container *ngSwitchCase="ControllerTypes.DropdownMulti">
      <answer-multi-select class="w-100" [inputContent]="inputContent"
        [formControlObj]="formGroup.controls[inputContent.inputContentGuid]">
      </answer-multi-select>
    </ng-container>
    <ng-container *ngSwitchCase="ControllerTypes.DropdownWithExtraText">
      <answer-select-with-text class="w-100" [inputContent]="inputContent"
        [formControlObj]="formGroup.controls[inputContent.inputContentGuid]">
      </answer-select-with-text>
    </ng-container>
    <ng-container *ngSwitchDefault>
      <div class="mt-2">
        <small> Type <i>{{ inputContent.inputControllerTypeName }}</i> is not supported yet. </small>
      </div>
    </ng-container>
  </ng-container>
</div>